module.exports = __webpack_public_path__ + "img/blue_background.14cc7487.jpg";